export const UPDATE_PROFILE_DATA = 'UPDATE_PROFILE_DATA'
export const UPDATE_PROFILE_DATA_ITEM = 'UPDATE_PROFILE_DATA_ITEM'
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA'
export const UNSET_PROFILE_DATA = 'UNSET_PROFILE_DATA'
